<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.add_new_client") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #446e80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Avatar Upload -->
          <base-image-upload-input
            col="12"
            identifier="client_avatar"
            :placeholder="$t('PLACEHOLDERS.client_logo')"
            @selectImage="selectImage"
          />
          <!-- End:: Avatar Upload -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.name')"
            v-model.trim="data.name"
            required
          />
          <!-- End:: Name Input -->

          <!-- Start:: Email Input -->
          <!-- <base-input
            col="6"
            type="email"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
            required
          /> -->
          <!-- End:: Email Input -->

          <!-- Start:: Mobile Input -->
          <!-- <base-input
            col="6"
            type="tel"
            :placeholder="$t('PLACEHOLDERS.mobile')"
            v-model.trim="data.mobile"
            required
          /> -->
          <!-- End:: Mobile Input -->

          <!-- Start:: Password Input -->
          <!-- <base-input
            col="6"
            type="password"
            :placeholder="$t('PLACEHOLDERS.password')"
            v-model.trim="data.password"
            required
          /> -->
          <!-- End:: Password Input -->

          <!-- Start:: Password Confirmation Input -->
          <!-- <base-input
            col="6"
            type="password"
            :placeholder="$t('PLACEHOLDERS.password_confirmation')"
            v-model.trim="data.password_confirmation"
            required
          /> -->
          <!-- End:: Password Confirmation Input -->

          <!-- Start:: Activation Switch Input -->
          <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="
                data.is_active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.is_active"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Activation Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "CreateClient",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        avatar: {
          path: null,
          file: null,
        },
        name: null,
        email: null,
        mobile: null,
        password: null,
        password_confirmation: null,
        is_active: true,
      },
      // End:: Data Collection To Send
    };
  },

  methods: {
    // Start:: Select Upload Image
    selectImage(selectedImage) {
      this.data.avatar = selectedImage;
    },
    // End:: Select Upload Image

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      if (!this.data.name) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.name"));
        return;
      }
      // if (!this.data.email) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.email"));
      //   return;
      // }
      // if (!this.data.mobile) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.mobile"));
      //   return;
      // }
      // if (!this.data.password) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.password"));
      //   return;
      // }
      // if (!this.data.password_confirmation) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.password_confirmation"));
      //   return;
      // }
      // if (this.data.password !== this.data.password_confirmation) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.password_mismatch"));
      //   return;
      // }
      // if (this.data.name.length < 3 || this.data.name.length > 50) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.name_length"));
      //   return;
      // }

      this.submitForm();
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();

      // Start:: Append Request Data
      REQUEST_DATA.append("name", this.data.name);
      REQUEST_DATA.append("email", this.data.email);
      REQUEST_DATA.append("mobile", this.data.mobile);
      REQUEST_DATA.append("password", this.data.password);
      REQUEST_DATA.append(
        "password_confirmation",
        this.data.password_confirmation
      );
      REQUEST_DATA.append("is_active", this.data.is_active ? 1 : 0);

      if (this.data.avatar.file) {
        REQUEST_DATA.append("avatar", this.data.avatar.file);
      }

      try {
        await this.$axios({
          method: "POST",
          url: `partners`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/our-clients/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },
};
</script>
